import { DateTime } from "luxon";

export class JobFilters {
  id?: string | undefined;
  startTerminalLatitude!: number;
  startTerminalLongitude!: number;
  endTerminalLatitude!: number;
  endTerminalLongitude!: number;
  startTime: DateTime | null | undefined;
  endTime: DateTime | null | undefined;
  startTerminalName!: string;
  endTerminalName!: string;
  maxLocations? : number;
  jobTemplate! : string;
  isFullDay? : boolean;
}
